// Generic Empty Action Type
export const NO_ACTION                                      = 'NO_ACTION';

// App
export const APP_BOOTSTRAP                                  = 'APP_BOOTSTRAP';
export const APP_INIT                                       =  'APP_INIT';
export const APP_POST_LOGIN_PROCESS                         = 'APP_POST_LOGIN_PROCESS';
export const APP_UTM_SET                                    = 'APP_UTM_SET';

// Authentication
export const AUTH_USER_SET                                  = 'AUTH_USER_SET';
export const AUTH_COMPANY_SET                               = 'AUTH_COMPANY_SET';
export const AUTH_DELETE                                    = 'AUTH_DELETE';

// Billing
export const BILLING_CREATE                                 = 'BILLING_CREATE';
export const BILLING_VIEW                                   = 'BILLING_VIEW';
export const BILLING_FETCH                                  = 'BILLING_FETCH';
export const BILLING_FETCH_ABORT                            = 'BILLING_FETCH_ABORT';
export const BILLING_FETCH_ERROR                            = 'BILLING_FETCH_ERROR';
export const BILLING_UPDATE                                 = 'BILLING_UPDATE';
export const BILLING_SET                                    = 'BILLING_SET';
export const BILLING_KEY_FETCH                              = 'BILLING_KEY_FETCH';
export const BILLING_KEY_SET                                = 'BILLING_KEY_SET';
export const BILLING_ESTIMATE_FETCH                         = 'BILLING_ESTIMATE_FETCH';
export const BILLING_ESTIMATE_FETCH_ABORT                   = 'BILLING_ESTIMATE_FETCH_ABORT';
export const BILLING_ESTIMATE_FETCH_ERROR                   = 'BILLING_ESTIMATE_FETCH_ERROR';
export const BILLING_ESTIMATE_SET                           = 'BILLING_ESTIMATE_SET';
export const BILLING_INVOICE_FETCH                          = 'BILLING_INVOICE_FETCH';
export const BILLING_INVOICE_FETCH_ABORT                    = 'BILLING_INVOICE_FETCH_ABORT';
export const BILLING_INVOICE_FETCH_ERROR                    = 'BILLING_INVOICE_FETCH_ERROR';
export const BILLING_INVOICES_FETCH                         = 'BILLING_INVOICES_FETCH';
export const BILLING_INVOICES_FETCH_ABORT                   = 'BILLING_INVOICES_FETCH_ABORT';
export const BILLING_INVOICES_FETCH_ERROR                   = 'BILLING_INVOICES_FETCH_ERROR';
export const BILLING_PLAN_CHANGE_START                      = 'BILLING_PLAN_CHANGE_START';
export const BILLING_USERS_FETCH                            = 'BILLING_USERS_FETCH';
export const BILLING_USERS_FETCH_MORE                       = 'BILLING_USERS_FETCH_MORE';
export const BILLING_USAGE_REPORT_FETCH                     = 'BILLING_USAGE_REPORT_FETCH';
export const BILLING_USAGE_REPORT_FETCH_ERROR               = 'BILLING_USAGE_REPORT_FETCH_ERROR';
export const BILLING_USAGE_REPORT_FETCH_ABORT               = 'BILLING_USAGE_REPORT_FETCH_ABORT';
export const BILLING_USAGE_REPORT_SET                       = 'BILLING_USAGE_REPORT_SET';
export const BILLING_SUBSCRIPTION_CANCEL                    = 'BILLING_SUBSCRIPTION_CANCEL';
export const BILLING_SUBSCRIBE                              = 'BILLING_SUBSCRIBE';
export const BILLING_SUBSCRIBE_ERROR                        = 'BILLING_SUBSCRIBE_ERROR';
export const BILLING_SUBSCRIBE_ABORT                        = 'BILLING_SUBSCRIBE_ABORT';
export const BILLING_SUBSCRIBE_START                        = 'BILLING_SUBSCRIBE_START';
export const BILLING_PAYMENT_START                          = 'BILLING_PAYMENT_START';
export const BILLING_DETAILS_START                          = 'BILLING_DETAILS_START';
export const BILLING_UPGRADE_REQUEST                        = 'BILLING_UPGRADE_REQUEST';
export const BILLING_TRIAL_START                            = 'BILLING_TRIAL_START';
export const BILLING_LOCATION_SUBSCRIPTION_UPDATE           = 'BILLING_LOCATION_SUBSCRIPTION_UPDATE';

// Cloudinary
export const CLOUDINARY_PICTURE_UPDATE                      = 'CLOUDINARY_PICTURE_UPDATE';

// Connection
export const CONNECTION_EDIT                                = 'CONNECTION_EDIT';
export const CONNECTION_FETCH                               = 'CONNECTION_FETCH';
export const CONNECTION_FETCH_SUCCESS                       = 'CONNECTION_FETCH_SUCCESS';
export const CONNECTION_DELETE                              = 'CONNECTION_DELETE';
export const CONNECTION_REMOVE                              = 'CONNECTION_REMOVE';
export const CONNECTION_PERMISSIONS_EDIT                    = 'CONNECTION_PERMISSIONS_EDIT';
export const CONNECTION_PERMISSIONS_FETCH                   = 'CONNECTION_PERMISSIONS_FETCH';
export const CONNECTION_PERMISSIONS_RELATION_SET            = 'CONNECTION_PERMISSIONS_RELATION_SET';
export const CONNECTION_POSITION_VIEWED_SET                 = 'CONNECTION_POSITION_VIEWED_SET';
export const CONNECTION_VIEWED_SET                          = 'CONNECTION_VIEWED_SET';
export const CONNECTION_REFERRER_SET                        = 'CONNECTION_REFERRER_SET';
export const CONNECTION_REFERRER_VIEW                       = 'CONNECTION_REFERRER_VIEW';
export const CONNECTION_UPDATE                              = 'CONNECTION_UPDATE';
export const CONNECTION_POSITIONS_DELETE                    = 'CONNECTION_POSITIONS_DELETE';
export const CONNECTION_POSITIONS_UPDATE                    = 'CONNECTION_POSITIONS_UPDATE';
export const CONNECTION_PERMISSIONS_FETCHING_SET            ='CONNECTION_PERMISSIONS_FETCHING_SET';
export const CONNECTION_ADD_WORKER                          = 'CONNECTION_ADD_WORKER';
export const CONNECTION_ADD_WORKER_START                    = 'CONNECTION_ADD_WORKER_START';
export const CONNECTION_AVAILABILITY_DELETE                 = 'CONNECTION_AVAILABILITY_DELETE';
export const CONNECTION_AVAILABILITY_REMOVE                 = 'CONNECTION_AVAILABILITY_REMOVE';
export const CONNECTION_AVAILABILITY_VIEWED_SET             = 'CONNECTION_AVAILABILITY_VIEWED_SET';
export const CONNECTION_AVAILABILITIES_SET                  = 'CONNECTION_AVAILABILITIES_SET';
export const CONNECTION_MERGE                               = 'CONNECTION_MERGE';
export const CONNECTION_MERGE_CANCEL                        = 'CONNECTION_MERGE_CANCEL';
export const CONNECTION_CERTIFICATIONS_FETCH                = 'CONNECTION_CERTIFICATIONS_FETCH';
export const CONNECTION_CERTIFICATIONS_SET                  = 'CONNECTION_CERTIFICATIONS_SET';
export const CONNECTION_CERTIFICATION_SET                   = 'CONNECTION_CERTIFICATION_SET';
export const CONNECTION_CERTIFICATION_ADD                   = 'CONNECTION_CERTIFICATION_ADD';
export const CONNECTION_CERTIFICATION_UPDATE                = 'CONNECTION_CERTIFICATION_UPDATE';
export const CONNECTION_CERTIFICATION_REMOVE                = 'CONNECTION_CERTIFICATION_REMOVE';
export const CONNECTION_CERTIFICATION_DELETE                = 'CONNECTION_CERTIFICATION_DELETE';

export const CONNECTION_FILTERS_FETCH                       = 'CONNECTION_FILTERS_FETCH';
export const CONNECTION_FILTERS_SET                         = 'CONNECTION_FILTERS_SET';
export const CONNECTION_FILTERS_UNSET                       = 'CONNECTION_FILTERS_UNSET';

export const CONNECTIONS_SEARCH_MORE                        = 'CONNECTIONS_SEARCH_MORE';
export const CONNECTIONS_SUMMARY_SET                        = 'TIMECARDS_SUMMARY_SET';

export const CONNECTIONS_COMPLIANCE_ASSIGN                  = 'CONNECTIONS_COMPLIANCE_ASSIGN';
export const CONNECTIONS_FETCH_ALL                          = 'CONNECTIONS_FETCH_ALL';
export const CONNECTIONS_FETCH                              = 'CONNECTIONS_FETCH';
export const CONNECTIONS_IMPORT                             = 'CONNECTIONS_IMPORT';
export const CONNECTIONS_SEARCH                             = 'CONNECTIONS_SEARCH';
export const CONNECTIONS_FETCH_MORE                         = 'CONNECTIONS_FETCH_MORE';
export const CONNECTIONS_VIEW                               = 'CONNECTIONS_VIEW';
export const CONNECTIONS_EXPORT                             = 'CONNECTIONS_EXPORT';
export const CONNECTIONS_EXPORT_START                       = 'CONNECTIONS_EXPORT_START';
export const CONNECTIONS_POSITION_START                     = 'CONNECTIONS_POSITION_START';
export const CONNECTIONS_SEND_INVITES                       = 'CONNECTIONS_SEND_INVITES';
export const CONNECTIONS_WORKER_POSITION_ASSIGN             = 'CONNECTIONS_WORKER_POSITION_ASSIGN';

// Company
export const COMPANY_FETCH                                  = 'COMPANY_FETCH';
export const COMPANY_FETCH_ABORT                            = 'COMPANY_FETCH_ABORT';
export const COMPANY_FETCH_ERROR                            = 'COMPANY_FETCH_ERROR';
export const COMPANY_UPDATE                                 = 'COMPANY_UPDATE';
export const COMPANY_DELETE                                 = 'COMPANY_DELETE';
export const COMPANY_SET                                    = 'COMPANY_SET';
export const COMPANY_FEATURES_SET                           = 'COMPANY_FEATURES_SET';
export const COMPANY_FEATURES_FETCH                         = 'COMPANY_FEATURES_FETCH';
export const COMPANY_LOCATION_IDS_SET                       = 'COMPANY_LOCATION_IDS_SET';
export const COMPANY_LOCATIONS_FETCH                        = 'COMPANY_LOCATIONS_FETCH';
export const COMPANY_SCHEDULES_FETCH                        = 'COMPANY_SCHEDULES_FETCH';

// Country
export const COUNTRY_FETCH                                  = 'COUNTRY_FETCH';
export const COUNTRY_SET                                    = 'COUNTRY_SET';

// Currency
export const CURRENCY_LOCALE_REFRESH                        = 'CURRENCY_LOCALE_REFRESH';

// Datetime formats
export const DATETIME_FORMAT_FETCH                          = 'DATETIME_FORMAT_FETCH';
export const DATETIME_FORMAT_SET                            = 'DATETIME_FORMAT_SET';

// Delivery
export const DELIVERY_ORDER_VIEWED_SET                      = 'DELIVERY_ORDER_VIEWED_SET';
export const DELIVERY_ORDER_DISPATCH_FETCH                  = 'DELIVERY_ORDER_DISPATCH_FETCH';
export const DELIVERY_ORDER_QUOTE_FETCH                     = 'DELIVERY_ORDER_QUOTE_FETCH';
export const DELIVERY_ORDER_QUOTE_SET                       = 'DELIVERY_ORDER_QUOTE_SET';
export const DELIVERY_ORDER_QUOTE_FETCHING_SET              = 'DELIVERY_ORDER_QUOTE_IS_FETCHING_SET';
export const DELIVERY_ORDER_DISPATCH                        = 'DELIVERY_ORDER_DISPATCH';
export const DELIVERY_ORDER_FETCH                           = 'DELIVERY_ORDER_FETCH';
export const DELIVERY_ORDER_FOCUSED_SET                     = 'DELIVERY_ORDER_FOCUSED_SET';
export const DELIVERY_ORDER_HELP_FETCH                      = 'DELIVERY_ORDER_HELP_FETCH';
export const DELIVERY_ORDER_UPDATE                          = 'DELIVERY_ORDER_UPDATE';
export const DELIVERY_ORDER_CREATE                          = 'DELIVERY_ORDER_CREATE';
export const DELIVERY_ORDER_CANCEL                          = 'DELIVERY_ORDER_CANCEL';
export const DELIVERY_ORDER_CANCEL_START                    = 'DELIVERY_ORDER_CANCEL_START';
export const DELIVERY_ORDER_UPDATE_ADDRESS_START            = 'DELIVERY_ORDER_UPDATE_ADDRESS_START';
export const DELIVERY_ORDER_FETCHING_SET                    = 'DELIVERY_ORDER_FETCHING_SET';
export const DELIVERY_ORDER_CONFIG_SET                      = 'DELIVERY_ORDER_CONFIG_SET';
export const DELIVERY_ORDER_CONFIG_FETCH                    = 'DELIVERY_ORDER_CONFIG_FETCH';
export const DELIVERY_ORDER_CONFIG_FETCHING_SET             = 'DELIVERY_ORDER_CONFIG_FETCHING_SET';
export const DELIVERY_ORDER_CONFIG_UPDATE                   = 'DELIVERY_ORDER_CONFIG_UPDATE';
export const DELIVERY_ORDER_REFUND_REQUEST_START            = 'DELIVERY_ORDER_REFUND_REQUEST_START';
export const DELIVERY_ORDER_REFUND_REQUEST                  = 'DELIVERY_ORDER_REFUND_REQUEST';
export const DELIVERY_ORDER_REASSIGN                        = 'DELIVERY_ORDER_REASSIGN';
export const DELIVERY_ORDER_REDISPATCH                      = 'DELIVERY_ORDER_REDISPATCH';
export const DELIVERY_ORDERS_TRACKING_FETCH                 = 'DELIVERY_ORDERS_TRACKING_FETCH';
export const DELIVERY_ORDER_MANAGER_NOTE_ADD_START          = 'DELIVERY_ORDER_MANAGER_NOTE_ADD_START';
export const DELIVERY_ORDER_NEW_SET                         = 'DELIVERY_ORDER_NEW_SET';

export const DELIVERY_ORDERS_SEARCH                         = 'DELIVERY_ORDERS_SEARCH';
export const DELIVERY_ORDERS_SEARCH_MORE                    = 'DELIVERY_ORDERS_SEARCH_MORE';
export const DELIVERY_ORDERS_FILTERS_FETCH                  = 'DELIVERY_ORDERS_FILTERS_FETCH';
export const DELIVERY_ORDERS_FILTERS_SET                    = 'DELIVERY_ORDERS_FILTERS_SET';
export const DELIVERY_ORDERS_POLLING_START                  = 'DELIVERY_ORDERS_POLLING_START';
export const DELIVERY_ORDERS_POLLING_STOP                   = 'DELIVERY_ORDERS_POLLING_STOP';
export const DELIVERY_ORDERS_SUMMARY_SET                    = 'DELIVERY_ORDERS_SUMMARY_SET';
export const DELIVERY_ORDERS_TRACKING_GROUP_FETCH           = 'DELIVERY_ORDERS_TRACKING_GROUP_FETCH';
export const DELIVERY_ORDERS_TRACKING_GROUP_SET             = 'DELIVERY_ORDERS_TRACKING_GROUP_SET';
export const DELIVERY_ORDERS_TRACKING_POLLING_START         = 'DELIVERY_ORDERS_TRACKING_POLLING_START';
export const DELIVERY_ORDERS_TRACKING_POLLING_STOP          = 'DELIVERY_ORDERS_TRACKING_POLLING_STOP';

export const DISPATCH_CONFIG_SET                            = 'DISPATCH_CONFIG_SET';
export const DISPATCH_CONFIG_FETCH                          = 'DISPATCH_CONFIG_FETCH';
export const DISPATCH_CONFIG_UPDATE                         = 'DISPATCH_CONFIG_UPDATE';
export const DISPATCH_CONFIG_FETCHING_SET                   = 'DISPATCH_CONFIG_FETCHING_SET';

export const DELIVERY_INTEGRATIONS_FETCH                    = 'DELIVERY_INTEGRATIONS_FETCH';
export const DELIVERY_INTEGRATIONS_SET                      = 'DELIVERY_INTEGRATIONS_SET';
export const DELIVERY_INTEGRATIONS_FETCHING_SET             = 'DELIVERY_INTEGRATIONS_FETCHING_SET';
export const DELIVERY_INTEGRATION_VIEWED_SET                = 'DELIVERY_INTEGRATION_VIEWED_SET';
export const DELIVERY_INTEGRATION_CONNECT                   = 'DELIVERY_INTEGRATION_CONNECT';
export const DELIVERY_INTEGRATION_DISCONNECT                = 'DELIVERY_INTEGRATION_DISCONNECT';
export const DELIVERY_INTEGRATION_DETAIL_LOAD               = 'DELIVERY_INTEGRATION_DETAIL_LOAD';
export const DELIVERY_INTEGRATION_DETAIL_SET                = 'DELIVERY_INTEGRATION_DETAIL_SET';
export const DELIVERY_INTEGRATION_SETTINGS_UPDATE           = 'DELIVERY_INTEGRATION_SETTINGS_UPDATE';

// Dev support
export const DEVSUPPORT_ORDERS_SEARCH                       = 'DEVSUPPORT_ORDERS_SEARCH';
export const DEVSUPPORT_ORDERS_SEARCH_MORE                  = 'DEVSUPPORT_ORDERS_SEARCH_MORE';
export const DEVSUPPORT_ORDERS_SUMMARY_SET                  = 'DEVSUPPORT_ORDERS_SUMMARY_SET';
export const DEVSUPPORT_ORDERS_POLLING_START                = 'DEVSUPPORT_ORDERS_POLLING_START';
export const DEVSUPPORT_ORDERS_POLLING_STOP                 = 'DEVSUPPORT_ORDERS_POLLING_STOP';
export const DEVSUPPORT_ORDER_FETCH                         = 'DEVSUPPORT_ORDER_FETCH';
export const DEVSUPPORT_ORDER_FETCHING_SET                  = 'DEVSUPPORT_ORDER_FETCHING_SET';
export const DEVSUPPORT_ORDER_VIEWED_SET                    = 'DEVSUPPORT_ORDER_VIEWED_SET';

// Drivers
export const DRIVERS_FETCH                                  = 'DRIVERS_FETCH';
export const DRIVER_CREATE                                  = 'DRIVER_CREATE';
export const DRIVER_DELETE                                  = 'DRIVER_DELETE';
export const DRIVER_INVITATION_RESEND                       = 'DRIVER_INVITATION_RESEND';

// API Keys
export const API_KEYS_FETCH                                 = 'API_KEYS_FETCH';
export const API_KEY_CREATE                                 = 'API_KEY_CREATE';
export const API_KEY_DELETE                                 = 'API_KEY_DELETE';

// Global
export const GLOBAL_FETCH                                   = 'GLOBAL_FETCH';
export const GLOBAL_SET                                     = 'GLOBAL_SET';
export const GLOBAL_INDUSTRIES_SET                          = 'GLOBAL_INDUSTRIES_SET';
export const GLOBAL_SETTINGS_FETCH                          = 'GLOBAL_SETTINGS_FETCH';
export const GLOBAL_SETTINGS_SET                            = 'GLOBAL_SETTINGS_SET';
export const GLOBAL_TIMEZONES_SET                           = 'GLOBAL_TIMEZONES_SET';
export const GLOBAL_DATETIME_FORMAT_SET                     = 'GLOBAL_DATETIME_FORMAT_SET';

// Industries
export const INDUSTRIES_FETCH                               = 'INDUSTRIES_FETCH';
export const INDUSTRIES_FETCH_ABORT                         = 'INDUSTRIES_FETCH_ABORT';
export const INDUSTRIES_FETCH_ERROR                         = 'INDUSTRIES_FETCH_ERROR';
export const INDUSTRIES_SET                                 = 'INDUSTRIES_SET';

// Intercom
export const INTERCOM_BOOT                                  = 'INTERCOM_BOOT';
export const INTERCOM_SHUTDOWN                              = 'INTERCOM_SHUTDOWN';

// List
export const LIST_DESELECT                                  = 'LIST_DESELECT';
export const LIST_DESELECT_BY_GROUP                         = 'LIST_DESELECT_BY_GROUP';
export const LIST_ITEM_SET                                  = 'LIST_ITEM_SET';
export const LIST_ITEM_UNSET                                = 'LIST_ITEM_UNSET';
export const LIST_ITEM_REMOVE                               = 'LIST_ITEM_REMOVE';
export const LIST_ITEMS_UNSET_ALL                           = 'LIST_ITEMS_UNSET_ALL';
export const LIST_MERGE                                     = 'LIST_MERGE';
export const LIST_SET                                       = 'LIST_SET';
export const LIST_SELECT                                    = 'LIST_SELECT';
export const LIST_SELECT_BY_GROUP                           = 'LIST_SELECT_BY_GROUP';
export const LIST_HIGHLIGHT                                 = 'LIST_HIGHLIGHT';
export const LIST_UNHIGHLIGHT                               = 'LIST_UNHIGHLIGHT';
export const LIST_FETCHING_SET                              = 'LIST_FETCHING_SET';
export const LIST_FETCHING_MORE_SET                         = 'LIST_FETCHING_MORE_SET';
export const LIST_ARRANGE_BY                                = 'LIST_ARRANGE_BY';
export const LIST_SORT_BY                                   = 'LIST_SORT_BY';
export const LIST_SORT_UNSET                                = 'LIST_SORT_UNSET';
export const LIST_SELECTION_MODE_SET                        = 'LIST_SELECTION_MODE_SET';
export const LIST_BULK_UPDATING_SET                         = 'LIST_BULK_UPDATING_SET';
export const LIST_COLUMN_IDS_SET                            = 'LIST_COLUMN_IDS_SET';

export const FILTER_SET                                     = 'FILTER_SET';
export const FILTER_UNSET                                   = 'FILTER_UNSET';

// App Reload
export const FORCE_RELOAD                                   = 'FORCE_RELOAD';

// Location
export const LOCATION_ADD_START                             = 'LOCATION_ADD_START';
export const LOCATION_FETCH                                 = 'LOCATION_FETCH';
export const LOCATION_SET                                   = 'LOCATION_SET';
export const LOCATION_ENTITY_SET                            = 'LOCATION_ENTITY_SET';
export const LOCATION_CREATE                                = 'LOCATION_CREATE';
export const LOCATION_UPDATE                                = 'LOCATION_UPDATE';
export const LOCATION_DELETE                                = 'LOCATION_DELETE';
export const LOCATION_DELETE_START                          = 'LOCATION_DELETE_START';
export const LOCATION_REMOVE                                = 'LOCATION_REMOVE';
export const LOCATION_SCHEDULES_FETCH                       = 'LOCATION_SCHEDULES_FETCH';
export const LOCATION_SCHEDULES_FETCH_ABORT                 = 'LOCATION_SCHEDULES_FETCH_ABORT';
export const LOCATION_VIEWED_SET                            = 'LOCATION_VIEWED_SET';
export const LOCATION_SCHEDULES_SET                         = 'LOCATION_SCHEDULES_SET';
export const LOCATION_COMPANY_SCHEDULES_RELATION_SET        = 'LOCATION_COMPANY_SCHEDULES_RELATION_SET';
export const LOCATION_COMPANY_SCHEDULES_RELATION_REMOVE     = 'LOCATION_COMPANY_SCHEDULES_RELATION_REMOVE';
export const LOCATION_USER_SCHEDULES_RELATION_SET           = 'LOCATION_USER_SCHEDULES_RELATION_SET';
export const LOCATION_USER_SCHEDULES_RELATION_REMOVE        = 'LOCATION_USER_SCHEDULES_RELATION_REMOVE';

export const LOCATIONS_FETCH                                = 'LOCATIONS_FETCH';
export const LOCATIONS_SET                                  = 'LOCATIONS_SET';

export const LOCATION_RULES_SET                             = 'LOCATION_RULES_SET';
export const LOCATION_RULES_VIEW                            = 'LOCATION_RULES_VIEW';
export const LOCATION_RULES_UPDATE                          = 'LOCATION_RULES_UPDATE';
export const LOCATION_RULES_UPDATE_ABORT                    = 'LOCATION_RULES_UPDATE_ABORT';
export const LOCATION_RULES_FETCH                           = 'LOCATION_RULES_FETCH';
export const LOCATION_RULES_FETCH_ABORT                     = 'LOCATION_RULES_FETCH_ABORT';
export const LOCATION_RULES_FETCH_MORE                      = 'LOCATION_RULES_FETCH_MORE';
export const LOCATION_RULES_FETCH_MORE_ABORT                = 'LOCATION_RULES_FETCH_MORE_ABORT';

// Live view
export const LIVEVIEW_ORDERS_SEARCH                         = 'LIVEVIEW_ORDERS_SEARCH';
export const LIVEVIEW_ORDERS_FETCHING_SET                   = 'LIVEVIEW_ORDERS_FETCHING_SET';
export const LIVEVIEW_ORDER_FETCH                           = 'LIVEVIEW_ORDER_FETCH';
export const LIVEVIEW_ORDER_FETCHING_SET                    = 'LIVEVIEW_ORDER_FETCHING_SET';
export const LIVEVIEW_ORDER_FOCUSED_SET                     = 'LIVEVIEW_ORDER_FOCUSED_SET';
export const LIVEVIEW_ORDER_VIEWED_SET                      = 'LIVEVIEW_ORDER_VIEWED_SET';
export const LIVEVIEW_ORDERS_POLLING_START                  = 'LIVEVIEW_ORDERS_POLLING_START';
export const LIVEVIEW_ORDERS_POLLING_STOP                   = 'LIVEVIEW_ORDERS_POLLING_STOP';

// Login
export const LOGIN                                          = 'LOGIN';
export const LOGIN_COMPANY                                  = 'LOGIN_COMPANY';
export const LOGIN_USER                                     = 'LOGIN_USER';
export const LOGIN_SUCCESSFUL                               = 'LOGIN_SUCCESSFUL';
export const LOGIN_ERROR                                    = 'LOGIN_ERROR';
export const LOGOUT                                         = 'LOGOUT';
export const LOGOUT_POST                                    = 'LOGOUT_POST';

// Password Management
export const PASSWORD_REQUEST_VERIFICATION_CODE             = 'PASSWORD_REQUEST_VERIFICATION_CODE';
export const PASSWORD_SUBMIT_VERIFICATION_CODE              = 'PASSWORD_SUBMIT_VERIFICATION_CODE';
export const PASSWORD_RESET                                 = 'PASSWORD_RESET';

// Generic Router Action Type;
export const ROUTER_GO                                      = 'ROUTER_GO';
export const ROUTER_GO_BACK                                 = 'ROUTER_GO_BACK';
export const ROUTER_NAVIGATION                              = 'ROUTER_NAVIGATION';
export const ROUTER_REDIRECT_TO_URL                         = 'ROUTER_REDIRECT_TO_URL';
export const ROUTER_TO_CHILD_NAVIGATION                     = 'ROUTER_TO_CHILD_NAVIGATION';
export const ROUTER_NAVIGATION_CANCEL                       = 'ROUTER_NAVIGATION_CANCEL';
export const ROUTER_NAVIGATION_SUCCESS                      = 'ROUTER_NAVIGATION_SUCCESS';
export const ROUTER_CANCEL                                  = 'ROUTER_CANCEL';
export const ROUTER_ERROR                                   = 'ROUTER_ERROR';
export const ROUTER_STATE_SET                               = 'ROUTER_STATE_SET';

// Toast
export const TOAST_SET                                      = 'TOAST_SET';
export const TOAST_FLUSH                                    = 'TOAST_FLUSH';
export const TOAST_SHOW                                     = 'TOAST_SHOW';

// Preferences

export const PREFERENCE_SET                                 = 'PREFERENCE_SET';
export const PREFERENCE_MERGE                               = 'PREFERENCE_MERGE';
export const PREFERENCE_COMPANY_SET                         = 'PREFERENCE_COMPANY_SET';
export const PREFERENCE_CONNECTIONS_SET                     = 'PREFERENCE_CONNECTIONS_SET';
export const PREFERENCE_NETWORK_SET                         = 'PREFERENCE_NETWORK_SET';
export const PREFERENCE_LOCATION_SET                        = 'PREFERENCE_LOCATION_SET';
export const PREFERENCE_MULTI_LOCATION_SET                  = 'PREFERENCE_MULTI_LOCATION_SET';
export const PREFERENCE_START_BAR_SET                       = 'PREFERENCE_START_BAR_SET';
export const PREFERENCE_DELIVERIES_SET                      = 'PREFERENCE_DELIVERIES_SET';
export const PREFERENCE_LIVEORDERS_SET                      = 'PREFERENCE_LIVEORDERS_SET';
export const PREFERENCE_REPORTS_SET                         = 'PREFERENCE_REPORTS_SET';
export const PREFERENCE_IHDSITES_SET                        = 'PREFERENCE_IHDSITES_SET';
export const PREFERENCE_COMPLIANCE_RULES_SET                = 'PREFERENCE_COMPLIANCE_RULES_SET';
export const PREFERENCE_COMPLIANCE_RULES_UNSET              = 'PREFERENCE_COMPLIANCE_RULES_UNSET';
export const PREFERENCE_EXPORT_REPORT_SET                   = 'PREFERENCE_EXPORT_REPORT_SET';
export const PREFERENCE_UNIT_MEASUREMENT_SET                = 'PREFERENCE_UNIT_MEASUREMENT_SET';
export const PREFERENCE_SAVE                                = 'PREFERENCE_SAVE';
export const PREFERENCE_FETCH                               = 'PREFERENCE_FETCH';
export const PREFERENCE_SORT_GROUP_SET                      = 'PREFERENCE_SORT_GROUP_SET';

// Registration
export const REGISTRATION_CREATE                            = 'REGISTRATION_CREATE';
export const REGISTRATION_FETCH                             = 'REGISTRATION_FETCH';
export const REGISTRATION_SET                               = 'REGISTRATION_SET';
export const REGISTRATION_UPDATE                            = 'REGISTRATION_UPDATE';
export const REGISTRATION_IHD_REGISTER                      = 'REGISTRATION_IHD_REGISTER';

// Reports
export const REPORTS_DELIVERIES_BY_DRIVER_FETCH             = 'REPORTS_DELIVERIES_BY_DRIVER_FETCH';
export const REPORTS_DELIVERIES_BY_DRIVER_SUMMARY_SET       = 'REPORTS_DELIVERIES_BY_DRIVER_SUMMARY_SET';
export const REPORTS_DELIVERIES_BY_DRIVER_HEADERS_SET       = 'REPORTS_DELIVERIES_BY_DRIVER_HEADERS_SET';

// Session
export const SESSION_LOCALE_SET                             = 'SESSION_LOCALE_SET';
export const SESSION_USER_FETCH                             = 'SESSION_USER_FETCH';
export const SESSION_USER_SET                               = 'SESSION_USER_SET';
export const SESSION_USER_PERMISSIONS_FETCH                 = 'SESSION_USER_PERMISSIONS_FETCH';
export const SESSION_USER_PERMISSIONS_SET                   = 'SESSION_USER_PERMISSIONS_SET';
export const SESSION_COMPANY_FETCH                          = 'SESSION_COMPANY_FETCH';
export const SESSION_COMPANY_SET                            = 'SESSION_COMPANY_SET';
export const SESSION_COMPANY_FEATURES_FETCH                 = 'SESSION_COMPANY_FEATURES_FETCH';
export const SESSION_COMPANY_FEATURES_SET                   = 'SESSION_COMPANY_FEATURES_SET';
export const SESSION_INIT                                   = 'SESSION_INIT';
export const SESSION_INIT_COMPLETE                          = 'SESSION_INIT_COMPLETE';
export const SESSION_REDIRECT_STATE_SET                     = 'SESSION_REDIRECT_STATE_SET';
export const SESSION_COUNTRY_FETCH                          = 'SESSION_COUNTRY_FETCH';
export const SESSION_COUNTRY_SET                            = 'SESSION_COUNTRY_SET';
export const SESSION_SKILLSETS_FETCH                        = 'SESSION_SKILLSETS_FETCH';
export const SESSION_SKILLSETS_SET                          = 'SESSION_SKILLSETS_SET';
export const SESSION_CLEAR                                  = 'SESSION_CLEAR';
export const SESSION_MOMENT_LOCALE_UPDATE                   = 'SESSION_MOMENT_LOCALE_UPDATE';

// Timezones
export const TIMEZONES_FETCH                                = 'TIMEZONES_FETCH';
export const TIMEZONES_SET                                  = 'TIMEZONES_SET';

// User (Logged in user)
export const USER_UPDATE                                    = 'USER_UPDATE';
export const USER_EMAIL_UPDATE                              = 'USER_EMAIL_UPDATE';
export const USER_PHONE_UPDATE                              = 'USER_PHONE_UPDATE';
export const USER_SET                                       = 'USER_SET';

// Users (Other users)
export const USERS_CREATE                                   = 'USERS_CREATE';
export const USERS_DELETE                                   = 'USERS_DELETE';
export const USERS_FETCH                                    = 'USERS_FETCH';
export const USERS_INVITATION_RESEND                        = 'USERS_INVITATION_RESEND';

// User datetime formats
export const USER_DATETIME_FORMAT_FETCH                     = 'USER_DATETIME_FORMAT_FETCH';
export const USER_DATETIME_FORMAT_SET                       = 'USER_DATETIME_FORMAT_SET';